// extracted by mini-css-extract-plugin
export default {"container":"FormCheckBox_container__+TKn4","checkmark":"FormCheckBox_checkmark__fJlqQ"};